module.exports = "https://web-assets.ifttt.com/packs/media/docs/service_page-f60d3224.png";